import type { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: 'metrics',
    name: 'metrics',
    component: () => import('@/modules/metrics/pages/metrics-view.vue'),
    meta: {
      title: 'Metrics - Workflow',
    },
  }
];

export default routes;